<template>
  <div class="flex flex-col items-center">
    <div class="max-w-5xl w-full">

      <h2 class="text-2xl font-medium p-4 border-b-2 border-red-600">
        Market Research
      </h2>

      <img
        src="../../assets/img/market_research_banner.jpg"
        alt="Market Research Banner"
        class="object-cover w-full lg:h-96 h-80 mt-4"
      >

      <div class="p-4">
        <p class="py-4">
          Deciding a right destination to open a new operation is always not easy.
          Choosing the wrong location (country/cities) can lead to an organisational
          crisis. Prepare all the ground work and get enough information about your
          chosen location supported by statistics and market information!
        </p>
        <p class="py-2">
          We help to:
        </p>
        <ul class="px-4 pb-4 list-disc text-red-700">
          <li>
            Research on the current situation, e.g. demography, investment
            conditions, people concerns
          </li>
          <li>
            Backup by statistics information, e.g. economic information,
            labour supply and quality
          </li>
          <li>
            Provide market intelligence, e.g. pay levels, pay increase rates, attrition rate
          </li>
          <li>Keep you informed on latest trends / industry practice</li>
          <li>Suggest on better locations (country/city)</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>

<script>
export default {};
</script>
